 
export enum NmvsActionType {
  Unknown = 0,
  Verify = 1,
  Sample = 2,
  Dispense = 3,
  UndoDispense = 4,
  UndoSample = 5,
  Destroy = 6
}


// WEBPACK FOOTER //
// ./src/types/nmvs-action-type.ts